import { Separator } from "@fluentui/react";
import React from "react";
import { LoadingButton, Shimmer, Stack, Text, WarningMessage } from "sprint-common-web";

interface GenerateAccessKeyStackProps {
    bucketName: string;
    isAccessKeyGenerating: boolean;
    isLoading: boolean;
    onClick(): void;
}
export const GenerateAccessKeyStack: React.VFC<GenerateAccessKeyStackProps> = ({
    bucketName,
    isAccessKeyGenerating,
    isLoading,
    onClick
}: GenerateAccessKeyStackProps) => {
    if (isLoading) {
        return <Shimmer />;
    }

    return (
        <Stack horizontalAlign="center" styles={{ root: { width: "100%" } }}>
            <Stack styles={{ root: { width: "100%", height: "350px" } }}>
                <Text nowrap={false} styles={{ root: { textAlign: "center" } }}>
                    You are about to generate access key for: <br />
                    <b>{bucketName}</b>
                    <br />
                    <br />
                    <WarningMessage message="Please note that any existing key will be no longer active" />
                </Text>
            </Stack>
            <Stack styles={{ root: { width: "100%" } }}>
                <Separator />
                <LoadingButton text="Generate" onClick={onClick} isLoading={isAccessKeyGenerating} />
            </Stack>
        </Stack>
    );
};
